import React from 'react'

import WhatsappSvg from '../../media/WhatsApp.svg'

const WhatsApp = ({ openLink }) => {
    return (
        <div onClick={() => openLink('https://api.whatsapp.com/send?phone=905333536406')} className='fixed bottom-5 right-5 h-12 w-12 md:w-12 md:h-12 z-40 cursor-pointer'>
            <img className='h-full w-full' src={WhatsappSvg} alt=''></img>
        </div>
    )
}

export default WhatsApp